import exp from "constants";
import React, { createContext } from "react";

interface PlatformContextType {
  isDesktop: boolean;
  setDesktop: (isDesktop: boolean) => void;
}
export const PlatformContext = createContext<PlatformContextType | undefined>(
  undefined
);
